import './values-row.sass';

import React from 'react';
import { Translate } from 'react-redux-i18n';

export default function ValuesItem (props) {
  return (
    <div className='track-statistics-report-row row'>
      <div className='track-statistics-report-row__col-title'>
        { props.title ? props.title : <b><Translate value='trackStatistics.valuesRow.title' /></b> }
      </div>
      <div className='track-statistics-report-row__col-value'>
        { props.count ? props.count : <b><Translate value='trackStatistics.valuesRow.count' /></b> }
      </div>
      <div className='track-statistics-report-row__col-value'>
        { props.min ? props.min : <b><Translate value='trackStatistics.valuesRow.min' /></b> }
      </div>
      <div className='track-statistics-report-row__col-value'>
        { props.avg ? props.avg : <b><Translate value='trackStatistics.valuesRow.avg' /></b> }
      </div>
      <div className='track-statistics-report-row__col-value'>
        { props.sum ? props.sum : <b><Translate value='trackStatistics.valuesRow.sum' /></b> }
      </div>
      <div className='track-statistics-report-row__col-value'>
        { props.max ? props.max : <b><Translate value='trackStatistics.valuesRow.max' /></b> }
      </div>
    </div>
  );
}
